import { constructAsync } from '../../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../../webmodule-common/other/dispose';
import { FabricationPurchaseOrderListView } from '../../fabrication-purchase-orders/views/fabrication-purchase-order-list-view';
import { html } from 'lit';
import { TabbedPageBase } from '../../pages/helpers/page-base';
import { userDataStore } from '../../common/current-user-data-store';

@customElement('app-fabrication-purchase-orders')
export class AppFabricationPurchaseOrdersPage extends TabbedPageBase {
  @state()
  private listView: FabricationPurchaseOrderListView | null = null;

  constructor() {
    super();
  }

  protected async setActiveTabByHash() {
    await this.listView?.setActiveTabByHash();
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div class="page-content">
        <div class="page-container">${this.listView?.ui}</div>
      </div>
    `;
  }

  meta() {
    return {
      title: () => 'Purchase Orders',
      description: 'Fabrication purchase orders'
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    this.listView = new FabricationPurchaseOrderListView({
      branchId: async () => {
        await userDataStore.loadCoreDetails();
        return userDataStore.defaultBranch?.id ?? '';
      }
    });
    await constructAsync(this.listView);
    await super.afterUserConnected();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.listView);
    this.listView = null;
  }
}
